import * as React from 'react';
import styled from 'styled-components';
import { AI2Logo } from '../logos/AI2Logo';
import { Content } from '../Layout';
export const AI2Banner = React.forwardRef(({ children }, ref) => (React.createElement(DarkBanner, { ref: ref },
    React.createElement(BannerContent, null, children || (React.createElement(BannerLink, { href: "https://allenai.org" },
        React.createElement(AI2Logo, { color: "white", size: "micro" })))))));
export const BannerLink = styled.a `
    display: inline-block;
    padding: 5px 0 2px 0;
`;
const BannerContent = styled(Content) `
    padding-top: 0;
    padding-bottom: 0;
`;
const DarkBanner = styled.div `
    background: ${({ theme }) => theme.palette.background.dark.toString()};
    padding: ${({ theme }) => `${theme.spacing.xxs} 0`};
    line-height: 1;
`;
//# sourceMappingURL=AI2Banner.js.map